import { useMutation } from '@tanstack/react-query';

import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions/';

import { renameFolder } from '../../api/folders';

export function useRenameFolder(items: string[]) {
  return useMutation({
    mutationFn: renameFolder,
    onError: (error) => {
      apiToaster([...items], QuizToastActions.RENAME, error);
    },
  });
}
